import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';

@Directive({
  selector: 'form[formGroup]'
})
export class scrollToErrorDirective {

  constructor(private el: ElementRef) {}

  @Input() formGroup: NgForm;
  @Input() tab:any;
  @Input() modal:any;

  @HostListener('submit')
  scrollToError() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid:not(div)');
    if (invalidElements.length > 0) {
      let invalidElement=invalidElements[0];
      //check form contains modal start
      if(this.modal!=undefined){
        invalidElement.scrollIntoView({
          behavior: 'smooth'
        });
        return false;
      }
      //check form contains modal end
      //check form contains tabs start
      if(this.tab!=undefined){
        let evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        let tabPane=invalidElement.closest(".tab-pane");
        let elem=document.querySelector("[href='#"+tabPane.getAttribute("id")+"']");
        if(!tabPane.classList.contains('active')){
          elem.dispatchEvent(evt);
          setTimeout(()=>{
            this.scrollTo(document.documentElement.scrollTop+invalidElement.getBoundingClientRect().top-110);
          },500);
          return false;
        }
      }
      //check form contains tabs end
      this.scrollTo(document.documentElement.scrollTop+invalidElement.getBoundingClientRect().top-110);
    }
  }
  scrollTo(top){
    window.scrollTo({
      top: top,
      left: 0,
      behavior: 'smooth'
    }); 
  }
}


// WEBPACK FOOTER //
// ./src/app/directive/scroll-to-error.directive.ts